// extracted by mini-css-extract-plugin
export default {"imageWrapper":"oK-z","twoColumnImage":"pK-z"};